import { ButtonSettings } from './types';
import { Theme } from '../../../themeBase';

const commonSettings = {
  fontWeight: 2,
  fontFamily: 'secondary',
  borderRadius: 3,
  lineHeight: '100%',
  boxShadow: (props: Theme) => props.boxShadows.input,
  '&:focus-visible': {
    boxShadow: (props: Theme) => `0 0 0 3px ${props.colors.primary.light}`,
  },
};

export const buttonSettings: ButtonSettings = {
  componentVariants: {
    color: {
      prop: 'colorVariant',
      variants: {
        'solid-primary': {
          backgroundColor: 'primary.main',
          color: 'white.main',
          '&:hover': {
            backgroundColor: 'primary.dark',
            boxShadow: 'none',
          },
          '&:disabled': {
            backgroundColor: 'primary.light',
            boxShadow: 'none',
          },
        },
        'outline-primary': {
          backgroundColor: 'transparent',
          color: 'primary.main',
          borderColor: 'primary.main',
          borderWidth: '1px',
          borderStyle: 'solid',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: 'primary.light',
          },
          '&:disabled': {
            backgroundColor: 'transparent',
            color: 'primary.light',
            borderColor: 'primary.light',
          },
        },
        'solid-secondary': {
          backgroundColor: 'secondary.main',
          color: 'black.main',
          borderColor: 'gray.light',
          borderWidth: '1px',
          borderStyle: 'solid',
          '&:hover': {
            backgroundColor: 'secondary.dark',
            boxShadow: 'none',
          },
          '&:disabled': {
            backgroundColor: 'gray.light',
            color: 'white.main',
            border: 'none',
            boxShadow: 'none',
          },
        },
        'outline-secondary': {
          backgroundColor: 'transparent',
          color: 'black.main',
          borderColor: 'gray.light',
          borderWidth: '1px',
          borderStyle: 'solid',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: 'secondary.dark',
          },
          '&:disabled': {
            backgroundColor: 'transparent',
            color: 'gray.light',
          },
        },
        'solid-success': {
          backgroundColor: 'success.main',
          color: 'white.main',
          '&:hover': {
            backgroundColor: 'success.dark',
            boxShadow: 'none',
          },
          '&:disabled': {
            backgroundColor: 'success.light',
            boxShadow: 'none',
          },
        },
        'outline-success': {
          backgroundColor: 'transparent',
          color: 'success.main',
          borderColor: 'success.main',
          borderWidth: '1px',
          borderStyle: 'solid',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: 'success.light',
          },
          '&:disabled': {
            backgroundColor: 'transparent',
            color: 'success.light',
            borderColor: 'success.light',
          },
        },
        'solid-danger': {
          backgroundColor: 'danger.main',
          color: 'white.main',
          '&:hover': {
            backgroundColor: 'danger.dark',
            boxShadow: 'none',
          },
          '&:disabled': {
            backgroundColor: 'danger.light',
            boxShadow: 'none',
          },
        },
        'outline-danger': {
          backgroundColor: 'transparent',
          color: 'danger.main',
          borderColor: 'danger.main',
          borderWidth: '1px',
          borderStyle: 'solid',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: 'danger.light',
          },
          '&:disabled': {
            backgroundColor: 'transparent',
            color: 'danger.light',
            borderColor: 'danger.light',
          },
        },
      },
    },
    size: {
      prop: 'size',
      variants: {
        small: {
          paddingTop: '2',
          paddingBottom: '2',
          paddingLeft: '3',
          paddingRight: '3',
          fontSize: '0',
          lineHeight: '0',
          ...commonSettings,
        },
        medium: {
          paddingTop: '3',
          paddingBottom: '3',
          paddingLeft: '5',
          paddingRight: '5',
          fontSize: '1',
          lineHeight: '1',
          ...commonSettings,
        },
      },
    },
    iconSize: {
      prop: 'iconSize',
      variants: {
        small: {
          width: '0',
          height: '0',
        },
        medium: {
          width: '1',
          height: '1',
        },
      },
    },
  },
};
